import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustedBar } from './components/TrustedBar';
import { PainPointsSection } from './components/PainPointsSection';
import { LeadsArchSection } from './components/LeadsArchSection';
import { ChoosePathSection } from './components/ChoosePathSection';
import { AboutSection } from './components/AboutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustedBar data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <LeadsArchSection data-id="element-6" />
        <ChoosePathSection data-id="element-7" />
        <AboutSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <FinalCtaSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}